import React, { useState, useEffect } from 'react';
import '../assets/styles/VideoGuides.scss';
import videoGuidesData from '../config/videoGuidesData';

// This is a standalone page component that doesn't rely on site context

const VideoGuidesPage = ({ siteId }) => {
  console.log("Accessed from site ID:", siteId);
  
  // State for active category filter
  const [activeCategory, setActiveCategory] = useState('all');
  // State for filtered videos
  const [filteredVideos, setFilteredVideos] = useState([]);
  
  // Function to navigate back to the dashboard/homepage
  const navigateToDashboard = () => {

    window.location.href = `/sites/${siteId}`;
  };
  
  // Filter videos when active category changes
  useEffect(() => {
    if (activeCategory === 'all') {
      setFilteredVideos(videoGuidesData.videos);
    } else {
      const filtered = videoGuidesData.videos.filter(
        video => video.category === activeCategory
      );
      setFilteredVideos(filtered);
    }
  }, [activeCategory]);
  
  // Handle category button click
  const handleCategoryClick = (categoryId) => {
    setActiveCategory(categoryId);
  };
  
  return (
    <div className="video-guides-page">
      <div className="dashboard-nav">
        <button 
          className="dashboard-button" 
          onClick={navigateToDashboard}
          type="button"
        >
          <span className="dashboard-icon">←</span>
          My Dashboard
        </button>
      </div>
      
      <h1>Video Guides</h1>
      
      <div className="category-filters">
        {videoGuidesData.categories.map(category => (
          <button 
            key={category.id}
            className={activeCategory === category.id ? 'active' : ''}
            onClick={() => handleCategoryClick(category.id)}
          >
            {category.name}
          </button>
        ))}
      </div>
      
      <div className="video-grid">
        {filteredVideos.length > 0 ? (
          filteredVideos.map(video => (
            <div 
              key={video.id}
              className="video-card" 
              onClick={() => window.open(video.url, '_blank')}
            >
              <div className="video-thumbnail" style={video.thumbnail ? { backgroundImage: `url(${video.thumbnail})`, backgroundSize: 'cover', backgroundPosition: 'center' } : {}}>
                <div className="play-button">
                  <div className="play-icon"></div>
                </div>
              </div>
              <div className="video-info">
                <h3>{video.title}</h3>
                <p>{video.description}</p>
                <div className="category-tag">
                  {videoGuidesData.categories.find(cat => cat.id === video.category)?.name || video.category}
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="no-videos-message">
            <p>No videos found for this category. Please try another filter.</p>
          </div>
        )}
      </div>
      
      <div className="resources-section">
        <h2>Additional Resources</h2>
        <div className="resources-grid">
          {videoGuidesData.resources.map(resource => (
            <a 
              key={resource.id}
              href={resource.url} 
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: 'none', color: 'inherit' }}
            >
              <div className="resource-card">
                <div className="resource-icon">
                  <span>{resource.icon}</span>
                </div>
                <h3>{resource.title}</h3>
                <p>{resource.description}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
      
      <div className="help-center-container">
        <a href="https://support.hellobar.com/support/home" className="button" target="_blank" rel="noopener noreferrer">
          Visit Help Center
        </a>
      </div>
    </div>
  );
};

export default VideoGuidesPage; 